<template>
  <footer class="main-footer">
    <hr>
    <section class="logo container">
      <div class="logo__container">
        <img src="../assets/logo.png" alt="Sequire Logo">
      </div>
      <div class="logo__text">
        <p>If you have any questions, send us an email at <a href="mailto:asiasummit@sequireconference.com">asiasummit@sequireconference.com</a></p>
      </div>
    </section>
  </footer>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/footer.scss';
</style>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    };
  },
};
</script>